import { connect } from 'react-redux'
import Details from './Details'

export default connect()(Details)
